import getField from '../getField'
import getValueInUnit from './getValueInUnit'

// get a named field's value in it's chosen unit
const getFieldValueInUnit = (obj, name, unit) => getValueInUnit(getField(obj, name), unit)

export default getFieldValueInUnit



// WEBPACK FOOTER //
// ./src/utilities/Data/User/getFieldValueInUnit.js